import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter);

window.popStateDetected = false;

window.addEventListener('popstate', () => {
    window.popStateDetected = true;
});

const routes = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ "../views/Home"),
        name: 'home'
    },
    /* User Login and Registration Routes */
    {
        path: '/user/login',
        component: () => import(/* webpackChunkName: "user" */ "../views/user/Login"),
        name: 'userLogin',
    },
    {
        path: '/user/register',
        component: () => import(/* webpackChunkName: "user" */ "../views/user/Register"),
        name: 'userRegister'
    },

    {
        path: '/game',
        component: () => import(/* webpackChunkName: "game" */ "../views/Game"),
        name: 'game'
    },
];


const router = new VueRouter({
    base: process.env.VUE_APP_BASE_ROUTE,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition)
            return savedPosition;
        else
            return {x: 0, y: 0};
    }
});

router.beforeEach(async function (to, from, next) {

    const isBack = window.popStateDetected;
    window.popStateDetected = false;

    if (isBack && store.state.popup.shown) {
        store.commit('popup/CLOSE_DIALOG', null, {root:true});
        next(false);
        return;
    }

    next();
});

export default router
